import React from 'react'
import Hero from '../Hero'
import HomeProject from '../HomeProject'
// import HomeFun from '../HomeFun'
import Footer from '../Footer'
import Bobby from '../Bobby'

function Home() {
  return (
    <>
      <Hero/>
      <Bobby/>
      <HomeProject/>
      <Footer/>
    </>
  )
}

export default Home
